import axios from 'axios';
import { API_URL } from './ApiConfig';
 

const api = axios.create({
  baseURL: API_URL,
});

 
api.interceptors.request.use(config => {
  const token = JSON.parse(localStorage.getItem('token'));

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

 
api.interceptors.response.use(
  response => response,  
  error => {
    
    if (error.response && error.response.status === 551) {
      alert('Sessão iniciada em outro dispositivo.');

    
      localStorage.removeItem('token');

     
      window.location.href = '/';
    }

    
    return Promise.reject(error);
  }
);

export default api;
